const firebaseConfig = {
    apiKey: "AIzaSyAri8847oGme2lK9TVqlR_0_r84ESAtFeM",
    authDomain: "health-care-63f40.firebaseapp.com",
    projectId: "health-care-63f40",
    storageBucket: "health-care-63f40.appspot.com",
    messagingSenderId: "590665262274",
    appId: "1:590665262274:web:6b166937a8b64f6473475b"
};

export default firebaseConfig;